export default {
	filterTitle: 'Klienti dle semaforu',
	pageTitle: 'Semafor',
	pageTitleSubordinateUser: 'Semafor podřízeného uživatele',
	contact1To2year: 'Kontakt před max. 2 lety',
	contact3To4year: 'Kontakt před více než 2, ale max. 4 lety',
	contact5To6year: 'Kontakt před více než 4, ale max. 6 lety',
	contact7AndLater: 'Kontakt před více než 6 lety',
	clientTransferGreenToOrange: 'Přesun klientů: zelená > oranžová',
	clientTransferOrangeToRed: 'Přesun klientů: oranžová > červená',
	clientTransferRedToGrey: 'Přesun klientů: červená > šedá',
	sum: 'Sumář',
	semaphoreCalculationInProcess: 'Probíhá nápočet Semaforu',
	semaphorePO: 'Právnická osoba - není zahrnuta do vyhodnocení Semaforu',
	graphCurrentStatus: 'Aktuální stav',
	graphCurrentStatusNoData: 'Data nejsou k dispozici',
	tableImpendingState: 'Hrozící stav',
	tableImpendingStateTo1Month: 'do 1 Měsíce',
	tableImpendingStateTo2Months: 'do 2 Měsíců',
	tableImpendingStateTo3Months: 'do 3 Měsíců',
	tableImpendingStateSum: 'Celkem',
	policyHolder: 'Pojistník',
	semaphoreFeedbackInputDate: 'Datum zadání ZV',
	semaphoreNoteInputDate: 'Datum zadání poznámky',
	semaphoreFeedbackNote: 'Text poznámky',
	semaphoreLastCommunicationWithClient: 'Poslední kontakt s klientem',
	semaphoreLastCommunicationWhen: 'KDY',
	semaphoreLastCommunicationByWho: 'KÝM',
	semaphoreLastCommunicationType: 'TYP KONTAKTU',
	feedbackDetailModalTitle: 'Zpětná vazba',
	feedbackDetail: 'Detail ZV',
	feedbackDetailNoteTitle: 'Poznámka k semaforu',
	feedbackDetailNote: 'Poznámka',
	feedbackDetailRevertChanges: 'Vrátit změny',
	feedbackLastModified: 'Naposledy změněno',
	tooManyResults:
		'Počet klientů k zobrazení je větší než 500. Zadejte, případně zpřesněte filtrovací kritéria a pokuste se zobrazení opakovat.',
	surname: 'Příjmení',
	firstName: 'Jméno',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	productDomain: 'Produktová oblast',
	notInsuredProductDomain: 'Nemá pojištěno',
	municipality: 'Obec',
	zipCode: 'PSČ',
	feedback: 'Zpětná vazba',
	birthYearFrom: 'Rok narození od',
	birthYearTo: 'Rok narození do',
	semaphore: 'Semafor',
	impendingState: 'Hrozící stav',
};
